@if (error_recipes) {
<div class="justify-center mt-4">
  <div class="flex flex-row text-e-orange" id="recipes_error">
    <small>{{'recipe.error_with_retrieving_recipes' | translate}}</small>
  </div>
</div>
}

@if (shownRecipes?.length >0 || loading) {

  <div #recipelist [ngClass]="container_class">
    @if(loading && shownRecipes.length === 0){
    @for(item of [0,1,2,3,4,5,6,7,8,9]; track item){
    <div class="min-w-80" [ngClass]="{'h-[480]': !condensed, 'h-[300px]': condensed}">
      <app-placeholder preset="{{condensed? 'RECIPE_CONDENSED': 'RECIPE'}}"></app-placeholder>
    </div>
    }
    }
    @for (recipe of shownRecipes; track $index) {
    <ng-container *ngTemplateOutlet="recipeTemplate;context:{$implicit:recipe, index: $index}"></ng-container>
    }

    @if (loading) {
    <div class="flex flex-col justify-center mb-3 mt-2">
      <h3 class="pb-3 mx-auto">{{'common.loading' | translate}}</h3>
      <app-loader class="mx-auto"></app-loader>
    </div>
    }

  </div>

  @if (_deliverydate && _allRecipes?.length > 0 && _lifestyleids?.length > 0 && showallbtn && (shownRecipes?.length < _allRecipes?.length)) {
  <div class="flex flex-row justify-center">
    <button (click)="showAllRecipes()" class="button rounded-full my-6 mx-auto flex items-center gap-2 text-[0.75rem] text-white">
      {{'recipe.show_all' | translate}}
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>
  }

  @if(horizontal){
  <div class="hidden md:flex">
    <button title="slides naar links"
      class="flex swiper-button-prev-slide absolute top-auto left-[150px] bottom-[50px] md:bottom-auto md:left-[-65px] md:top-[calc(50%-22px)] justify-center items-center transition-opacity disabled:opacity-25"
      (click)="swipeLeft()" [disabled]="scrollPosition === 0">
      <img alt="slide-left" class="h-4 rotate-180" src="./assets/images/icons/arrow_right.svg" />
    </button>

    <button title="slides naar rechts"
      class="flex swiper-button-next-slide absolute top-auto right-[150px] bottom-[50px] md:right-[-75px] md:top-[calc(50%-22px)] justify-center items-center transition-opacity disabled:opacity-25"
      (click)="swipeRight()" [disabled]="scrollEnd">
      <img alt="slide-right" class="h-4" src="./assets/images/icons/arrow_right.svg" />
    </button>
  </div>
  }
}